<div>
  <div
    class="campaign-overview-component flex-column py-4 px-3 w-100"
    [ngClass]="{ 'comment-right-panel-expanded': isCommentPageCommentExpanded }">
    <div class="d-flex flex-column mx-auto">
      @if (canAccessCampaign) {
        <div class="d-block">
          <div class="d-none d-md-block">
            <div class="d-flex align-items-center page-tab-control">
              <div class="section-title d-flex align-items-center" [ngClass]="{ collapse: isCampaignCollapse }">
                <div
                  class="d-flex align-items-center pointer"
                  (click)="isCampaignCollapse = !isCampaignCollapse"
                  [attr.aria-expanded]="isCampaignCollapse"
                  aria-controls="project-collapse-control">
                  <i class="mtm-icon mtm-icon-right-triangle-black"></i>
                  <span class="px-3 capital-1st-latter">{{ headerLabel | translate }}</span>
                </div>
              </div>
              <div class="d-flex align-items-center ms-auto project-nav-tabs">
                <div
                  class="tab-item pointer text-center"
                  (click)="allItems(); activeTab = 'all'"
                  [ngClass]="{ active: isAll }">
                  <span>{{ 'All' | translate }}</span>
                </div>
                <div
                  class="tab-item pointer text-center"
                  (click)="favoriteItems(); activeTab = 'favorites'"
                  [ngClass]="{ active: isFavorites }">
                  <span>{{ 'Favorites' | translate }}</span>
                </div>
                <div
                  class="tab-item pointer text-center"
                  (click)="getArchiveCampaign(); activeTab = 'archived'"
                  [ngClass]="{ active: isArchived }">
                  <span>{{ 'Archived' | translate }}</span>
                </div>
                <div class="d-flex tab-item p-0">
                  @if (canCreateDriveCampaign) {
                    <div ngbDropdown class="new-dropdown">
                      <button
                        (click)="hasSimulator ? $event.stopPropagation() : createCampaignDrive($event)"
                        class="btn btn-orange d-flex align-items-center justify-content-center text-uppercase position-relative text-nowrap btn-new-group">
                        <div
                          class="d-flex align-items-center justify-content-center mx-4"
                          (click)="$event.stopPropagation(); createCampaignDrive($event)">
                          <i
                            class="fa fa-plus d-flex align-items-center justify-content-center me-2"
                            aria-hidden="true"></i>
                          <span class="text-uppercase button-title">{{ 'new' | translate }}</span>
                        </div>
                        @if (hasSimulator) {
                          <span
                            ngbDropdownToggle
                            class="d-flex justify-content-center align-items-center toggle mx-auto">
                            <i
                              class="d-flex align-items-center justify-content-center fa fa-chevron-down ms-2"
                              aria-hidden="true"></i>
                          </span>
                        }
                      </button>
                      @if (hasSimulator) {
                        <div ngbDropdownMenu class="dropdown-menu">
                          <button
                            class="btn d-flex align-items-center dropdown-item"
                            (click)="$event.stopPropagation(); goToSimulator()">
                            <span class="text-uppercase button-title">{{
                              'timelineSimulator_newSimulation' | translate
                            }}</span>
                          </button>
                          <button
                            class="btn d-flex align-items-center dropdown-item"
                            (click)="$event.stopPropagation(); createCampaignDrive($event)">
                            <span class="text-uppercase button-title">{{ newCampaignLabel | translate }}</span>
                          </button>
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
          <div class="d-block d-md-none">
            <div class="d-flex flex-column page-tab-control">
              <div
                class="section-title section-title-mobile pointer d-flex align-items-center w-100 mb-2"
                [ngClass]="{ collapse: isCampaignCollapse }">
                <div
                  class="d-flex align-items-center pointer"
                  (click)="isCampaignCollapse = !isCampaignCollapse"
                  [attr.aria-expanded]="isCampaignCollapse"
                  aria-controls="project-collapse-control">
                  <i class="mtm-icon mtm-icon-right-triangle-black"></i>
                  <span class="px-3 capital-1st-latter">{{ headerLabel | translate }}</span>
                </div>
              </div>
              <div class="d-flex align-items-center project-nav-tabs mb-3">
                <div
                  class="tab-item pointer w-100 text-center"
                  (click)="allItems(); activeTab = 'all'"
                  [ngClass]="{ active: isAll }">
                  <span>{{ 'All' | translate }}</span>
                </div>
                <div
                  class="tab-item pointer w-100 text-center"
                  (click)="favoriteItems(); activeTab = 'favorites'"
                  [ngClass]="{ active: isFavorites }">
                  <span>{{ 'Favorites' | translate }}</span>
                </div>
                <div
                  class="tab-item pointer w-100 text-center"
                  (click)="getArchiveCampaign(); activeTab = 'archived'"
                  [ngClass]="{ active: isArchived }">
                  <span>{{ 'Archived' | translate }}</span>
                </div>
              </div>

              <div class="d-flex flex-column new-buttons-group">
                @if (hasSimulator) {
                  <button
                    class="btn w-100 btn-orange text-uppercase position-relative btn-simulator text-nowrap py-1 px-4"
                    (click)="goToSimulator()">
                    <i class="p-1 fa fa-plus" aria-hidden="true"></i>
                    <span class="ms-2">{{ 'timelineSimulator_newSimulation' | translate }}</span>
                  </button>
                }

                @if (canCreateDriveCampaign) {
                  <button
                    class="btn w-100 btn-orange text-uppercase position-relative btn-new-project text-nowrap py-1 px-4"
                    (click)="createCampaignDrive($event)">
                    <i class="p-1 fa fa-plus" aria-hidden="true"></i>
                    <span class="ms-2">{{ newCampaignLabel | translate }}</span>
                  </button>
                }
              </div>
            </div>
          </div>
        </div>
        <div class="mt-4" (scroll)="handleItemsScroll()">
          @if (isCampaignCollapse) {
            @if (!isLoaded && !isError) {
              <div class="skeleton">
                <mtm-grid-skeleton
                  [borderRadius]="6"
                  [gridCount]="5"
                  [widthSizeInPixels]="320"
                  [HeightSizeInPixels]="240"></mtm-grid-skeleton>
              </div>
            }

            @if (isLoaded) {
              <div class="workspace-list" [ngbCollapse]="!isCampaignCollapse">
                @if (canCreateDriveCampaign && DriveCampaigns.length == 0 && !isError) {
                  <div class="pointer workspace">
                    <div
                      class="campaign-drive-btn d-flex justify-content-center align-items-center w-100"
                      (click)="createCampaignDrive($event)">
                      <button
                        class="btn btn-orange text-uppercase position-relative btn-new-project text-nowrap py-1 px-4"
                        [style.min-width]="'100px'"
                        [style.width]="'auto'"
                        (click)="createCampaignDrive($event)">
                        <i class="p-1 fa fa-plus" aria-hidden="true"></i>
                        <span class="ms-2">{{ newCampaignLabel | translate }}</span>
                      </button>
                    </div>
                  </div>
                }

                @if (isError) {
                  <div class="d-flex justify-content-center align-items-center w-75">
                    <span class="_600 f-12">{{ 'dashboard_somethingWentWrong' | translate }}</span>
                  </div>
                }

                @for (item of DriveCampaigns; track $index) {
                  <div class="pointer workspace" (click)="redirectToDashboard(item)">
                    <div class="card-img">
                      @if (item.logo) {
                        <img class="image-style" [src]="item.logo" (error)="item.logo = null" alt="item-logo" />
                      }
                      @if (!item.logo) {
                        <span
                          class="c-full-white profile-text text-uppercase h-100 w-100"
                          [style.background-color]="timelineService.getColorFromName(item.name)">
                          {{ item.name | slice: 0 : 2 }}
                        </span>
                      }

                      <span class="badge badge-edit-button">
                        @if (!item.isFavorite) {
                          <i
                            (click)="$event.stopImmediatePropagation(); markAsFavorite(item)"
                            class="fa fa-star-o"
                            aria-hidden="true"></i>
                        }
                        @if (item.isFavorite) {
                          <i
                            (click)="$event.stopImmediatePropagation(); removeFavorite(item)"
                            class="fa fa-star"
                            [style.color]="'#ffca4c'"
                            aria-hidden="true"></i>
                        }
                      </span>
                    </div>

                    <div class="card-block d-flex">
                      <div class="col ps-1">
                        <div class="row">
                          <div class="col">
                            <span
                              class="ellipse-text f-10 _700 brand-name"
                              [style.width]="'220px'"
                              [style.color]="'#898C98'"
                              >{{ item.workspaceName }}</span
                            >
                          </div>
                        </div>

                        <div class="row" [style.height]="'45px'">
                          <div class="col">
                            <span class="ellipse-text f-15 _700 c-mtm-full-black text-uppercase">{{
                              item.name | titlecase
                            }}</span>
                          </div>
                        </div>

                        <div class="d-flex flex-row mt-0">
                          <div class="d-flex" [style.max-width]="'max-content'">
                            <div class="item-count-circle d-flex justify-content-center align-items-center">
                              <span class="f-8 c-full-white _700">{{ item.numberOfProject }}</span>
                            </div>
                            <div class="ms-2">
                              <span class="f-10 _400">{{ 'projects' | translate }}</span>
                            </div>
                          </div>
                        </div>

                        <div class="d-flex align-items-center flex-sm-row flag-position" [style.gap]="'5px'">
                          <div class="d-flex" [style.max-width]="'max-content'">
                            <span class="f-10 _700 c-mtm-full-black text-uppercase text-nowrap"
                              >Due Date {{ parseTimestamp(item.expectedMad) | ngbDate }}</span
                            >
                          </div>

                          @if (hasActiveProduct) {
                            <div class="active-product-select-box">
                              <div
                                class="col d-flex align-items-start align-items-sm-center flex-column flex-sm-row"
                                (click)="$event.stopImmediatePropagation()">
                                <span class="_700 f-12 me-2 text-nowrap">{{ 'Active Product' | translate }}</span>
                                <div class="select-wrapper-active-product">
                                  <div
                                    class="top-content d-flex align-items-center"
                                    (click)="$event.stopImmediatePropagation()">
                                    <div
                                      ngbDropdown
                                      class="d-flex align-items-center"
                                      [autoClose]="true"
                                      [container]="'body'">
                                      <button
                                        [disabled]="!canEditStatus"
                                        (click)="$event.stopImmediatePropagation()"
                                        type="button"
                                        class="d-flex align-items-center btn project-status-dropdown"
                                        ngbDropdownToggle>
                                        <div
                                          class="d-flex align-items-center project-status {{ item.activeProduct }}"
                                          [style.min-width]="'80px'">
                                          <div class="project-union-icon-container">
                                            <i
                                              class="project-union-icon mtm-icon mtm-icon-union-{{
                                                item.activeProduct === 'Yes'
                                                  ? 'gray'
                                                  : item.activeProduct === 'No'
                                                    ? 'orange'
                                                    : 'green'
                                              }}"></i>
                                          </div>
                                          <span class="me-2">{{ item.activeProduct | translate }}</span>
                                          <i class="fa fa-chevron-down ms-auto pointer"></i>
                                        </div>
                                      </button>
                                      <div class="project-dropdown-menu" ngbDropdownMenu>
                                        @if (
                                          !item.activeProduct ||
                                          item.activeProduct === 'Finished' ||
                                          item.activeProduct === 'No'
                                        ) {
                                          <div
                                            (click)="
                                              $event.stopImmediatePropagation();
                                              changeDriveCampaignActiveProduct(item, 'Yes')
                                            "
                                            class="project-dropdown-item pt-1 pb-1 ps-2 pe-2"
                                            ngbDropdownItem>
                                            <div class="d-flex align-items-center project-status-display IN_PROGRESS">
                                              <i class="project-status-circle-color mtm-icon-union-gray me-2"></i>
                                              <span>{{ 'Yes' | translate }}</span>
                                            </div>
                                          </div>
                                        }

                                        @if (
                                          !item.activeProduct ||
                                          item.activeProduct === 'Yes' ||
                                          item.activeProduct === 'No'
                                        ) {
                                          <div
                                            (click)="
                                              $event.stopImmediatePropagation();
                                              changeDriveCampaignActiveProduct(item, 'Finished')
                                            "
                                            class="project-dropdown-item pt-1 pb-1 ps-2 pe-2"
                                            ngbDropdownItem>
                                            <div class="d-flex align-items-center project-status-display COMPLETED">
                                              <i class="project-status-circle-color mtm-icon-union-green me-2"></i>
                                              <span>{{ 'Finished' | translate }}</span>
                                            </div>
                                          </div>
                                        }

                                        @if (
                                          !item.activeProduct ||
                                          item.activeProduct === 'Yes' ||
                                          item.activeProduct === 'Finished'
                                        ) {
                                          <div
                                            (click)="
                                              $event.stopImmediatePropagation();
                                              changeDriveCampaignActiveProduct(item, 'No')
                                            "
                                            class="project-dropdown-item pt-1 pb-1 ps-2 pe-2"
                                            ngbDropdownItem>
                                            <div class="d-flex align-items-center project-status-display DELAYED">
                                              <i class="project-status-circle-color mtm-icon-union-orange me-2"></i>
                                              <span>{{ 'No' | translate }}</span>
                                            </div>
                                          </div>
                                        }
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          }

                          @if (!hasActiveProduct) {
                            <div class="p-0" [style.max-width]="'max-content'">
                              <div
                                class="top-content d-flex align-items-center"
                                (click)="$event.stopImmediatePropagation()">
                                <mtm-status-select
                                  [value]="item.status"
                                  [options]="campaignStatusOptions"
                                  [disabled]="!canEditStatus"
                                  (click)="$event.stopImmediatePropagation()"
                                  (valueChange)="changeDriveCampaignStatus(item, $event.value)" />
                              </div>
                            </div>
                          }
                        </div>
                      </div>

                      <div
                        class="pointer"
                        [style.height]="'20px'"
                        style="position: relative; top: -5px"
                        (click)="$event.stopImmediatePropagation()">
                        <div ngbDropdown class="dropdown" autoCloseDropdown container="body" placement="bottom-right">
                          <div class="dropdown-toggle-container" ngbDropdownToggle>
                            <div class="three-dot-icon">
                              <span></span>
                              <span></span>
                              <span></span>
                            </div>
                          </div>

                          <div ngbDropdownMenu class="dropdown-menu-start arrow_box" aria-labelledby="dropdownMenuLink">
                            <div class="col options hover-text">
                              @if (!inWorkspace && isWorkspaceEnabled) {
                                <div
                                  class="col pointer p-0 d-flex align-items-center my-3"
                                  (click)="gotoWorkspace(item)">
                                  <i class="_500 fa fa-home fa-lg" [style.color]="'#181E39'" aria-hidden="true"></i>
                                  <span class="ms-2 f-10 _700 text-uppercase"> {{ 'gotoWorkspace' | translate }}</span>
                                </div>
                              }

                              @if (!item.locked) {
                                <div
                                  class="col pointer p-0 d-flex align-items-center my-3"
                                  (click)="editCampaignDrive(item)">
                                  <i class="_500 fa fa-pencil fa-lg" [style.color]="'#181E39'" aria-hidden="true"></i>
                                  <span class="ms-2 f-10 _700"> {{ 'settings' | translate }}</span>
                                </div>
                              }

                              <div
                                class="col pointer p-0 d-flex align-items-center my-3"
                                (click)="!item.isFavorite ? markAsFavorite(item) : removeFavorite(item)">
                                @if (!item.isFavorite) {
                                  <i class="_500 fa fa-star-o fa-lg" [style.color]="'#181E39'" aria-hidden="true"></i>
                                  <span class="ms-2 f-10 _700 text-uppercase"> {{ 'markAsFavorite' | translate }}</span>
                                }
                                @if (item.isFavorite) {
                                  <i class="_500 fa fa-star fa-lg" [style.color]="'#ffca4c'" aria-hidden="true"></i>
                                  <span class="ms-2 f-10 _700 text-uppercase"> {{ 'removeFavorite' | translate }}</span>
                                }
                              </div>

                              @if (!item.locked) {
                                <div
                                  class="col pointer p-0 d-flex align-items-center my-3"
                                  [class.disabled]="item.isArchiving"
                                  (click)="!item.isArchiving && archiveDriveCampaign(item)">
                                  <img
                                    [style.color]="item.isArchiving ? '#ccc' : '#181E39'"
                                    width="15"
                                    height="12"
                                    src="../../../assets/svg/archive-svg.svg"
                                    alt="" />

                                  @if (!item.isArchiving && !item.archived) {
                                    <span class="ms-2 f-10 _700 text-uppercase">
                                      {{ 'archive' | translate }}
                                    </span>
                                  }
                                  @if (!item.isArchiving && item.archived) {
                                    <span class="ms-2 f-10 _700 text-uppercase">
                                      {{ 'unArchive' | translate }}
                                    </span>
                                  }
                                  @if (item.isArchiving) {
                                    <span class="ms-2 f-10 _700 text-uppercase" [style.color]="'#ccc'">
                                      {{ (item.archived ? 'unArchiving' : 'archiving') | translate }}...
                                    </span>
                                  }
                                </div>
                              }

                              @if (!item.locked || canDeleteCampaign) {
                                <div
                                  class="col pointer p-0 d-flex align-items-center my-3"
                                  (click)="deleteDriveCampaign(item)">
                                  <i class="_500 fa fa-trash-o fa-lg" [style.color]="'#181E39'" aria-hidden="true"></i>
                                  <span class="ms-2 f-10 _700"> {{ 'deleteReviewLink' | translate }} </span>
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                }

                @if (!isInit && isLoaded && hasNext) {
                  <div class="w-100" style="height: 30px" observeThis (visibilityChange)="loadMore($event)"> </div>
                }
              </div>
            }
          }
        </div>
      }

      <div [class.mt-5]="canAccessCampaign">
        <div class="d-block">
          <div class="d-none d-md-block">
            <div class="d-flex align-items-center page-tab-control">
              <div class="section-title d-flex align-items-center w-100" [ngClass]="{ collapse: isProjectCollapse }">
                <div
                  class="d-flex align-items-center pointer"
                  (click)="isProjectCollapse = !isProjectCollapse"
                  [attr.aria-expanded]="isProjectCollapse"
                  aria-controls="project-collapse-control">
                  <i class="mtm-icon mtm-icon-right-triangle-black"></i>
                  <span class="px-3 no-wrap">{{
                    (canAccessCampaign ? 'Stand-alone Projects' : 'Projects') | translate
                  }}</span>
                </div>
              </div>
              <div class="d-flex align-items-center ms-auto project-nav-tabs">
                <div
                  class="tab-item pointer text-center"
                  (click)="allProjectItems(); activeTab = 'all'"
                  [ngClass]="{ active: isAllProject }">
                  <span>{{ 'All' | translate }}</span>
                </div>
                <div
                  class="tab-item pointer text-center"
                  (click)="favoriteProjectItems(); activeTab = 'favorites'"
                  [ngClass]="{ active: isFavoritesProject }">
                  <span>{{ 'Favorites' | translate }}</span>
                </div>
                <div
                  class="tab-item pointer text-center"
                  (click)="getArchiveProjects(); activeTab = 'archived'"
                  [ngClass]="{ active: isArchivedProject }">
                  <span>{{ 'Archived' | translate }}</span>
                </div>
                @if (canCreateProject) {
                  <div class="tab-item p-0">
                    <button
                      class="btn btn-orange d-flex align-items-center justify-content-center text-uppercase position-relative btn-new-project text-nowrap"
                      (click)="createProject()">
                      <i class="p-1 fa fa-plus" aria-hidden="true"></i>
                      <span class="ms-2">{{ 'newProject' | translate }}</span>
                    </button>
                  </div>
                }
              </div>
            </div>
          </div>
          <div class="d-block d-md-none">
            <div class="d-flex flex-column page-tab-control">
              <div
                class="section-title section-title-mobile pointer d-flex align-items-center w-100 mb-2"
                [ngClass]="{ collapse: isProjectCollapse }">
                <div
                  class="d-flex align-items-center pointer"
                  (click)="isProjectCollapse = !isProjectCollapse"
                  [attr.aria-expanded]="isProjectCollapse"
                  aria-controls="project-collapse-control">
                  <i class="mtm-icon mtm-icon-right-triangle-black"></i>
                  <span class="px-3 no-wrap">{{ 'Stand-alone Projects' | translate }}</span>
                </div>
              </div>
              <div class="d-flex align-items-center project-nav-tabs mb-3">
                <div
                  class="tab-item pointer w-100 text-center"
                  (click)="allProjectItems(); activeTab = 'all'"
                  [ngClass]="{ active: isAllProject }">
                  <span>{{ 'All' | translate }}</span>
                </div>
                <div
                  class="tab-item pointer w-100 text-center"
                  (click)="favoriteProjectItems(); activeTab = 'favorites'"
                  [ngClass]="{ active: isFavoritesProject }">
                  <span>{{ 'Favorites' | translate }}</span>
                </div>
                <div
                  class="tab-item pointer w-100 text-center"
                  (click)="getArchiveProjects(); activeTab = 'archived'"
                  [ngClass]="{ active: isArchivedProject }">
                  <span>{{ 'Archived' | translate }}</span>
                </div>
              </div>
              <div class="d-block">
                @if (canCreateProject) {
                  <button
                    class="btn w-100 btn-orange text-uppercase position-relative btn-new-project text-nowrap py-1 px-4"
                    (click)="createProject()">
                    <i class="p-1 fa fa-plus" aria-hidden="true"></i>
                    <span class="ms-2">{{ 'newProject' | translate }}</span>
                  </button>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      <div [ngbCollapse]="!isProjectCollapse">
        @if (isProjectCollapse) {
          <mtm-projects
            [workspaceId]="workspaceId"
            [isProjectCollapse]="isProjectCollapse"
            [isCampaignProjects]="true"></mtm-projects>
        }
      </div>
    </div>
  </div>
</div>
<!-- breadcrumb section  -->
<ng-template #searchPanel>
  @if (isCriteriaForm1Enabled) {
    <div class="d-flex flex-md-row align-items-center justify-content-md-center search-panel cpd ms-auto">
      <div class="position-relative search-container">
        <input
          [(ngModel)]="searchDriveCampaign"
          class="search-box ps-2 pe-4"
          (ngModelChange)="searchDriveCampaigns()"
          type="text"
          placeholder="{{ 'search' | translate }}" />
        <i class="fa fa-search search-icon" aria-hidden="true"></i>
      </div>
      <div class="calendar-block d-flex">
        <div class="d-flex align-items-center w-100">
          <div class="d-flex align-items-center calendar-dropdown w-100" ngbDropdown>
            <div
              class="dropdown-toggle w-100 mt-auto d-flex align-items-center justify-content-end p-0 pointer"
              ngbDropdownToggle>
              <div class="d-flex gap-2 items-center">
                <span class="_400">{{ 'sortBy' | translate }}</span>
                <span class="_700">{{ calendarViewMode | translate }}</span>
              </div>
              <div class="calendar-icon-div pointer ms-2">
                <i class="fa fa-chevron-down" aria-hidden="true"></i>
              </div>
            </div>
            <div class="calendar-dropdown-menu w-100" ngbDropdownMenu>
              <div ngbDropdownItem (click)="selectCalendarMode('latest')">{{ 'last_updated' | translate }}</div>
              <div ngbDropdownItem (click)="selectCalendarMode('week')">{{ 'week' | translate }}</div>
              <div ngbDropdownItem (click)="selectCalendarMode('3_months')">{{
                'calendarView_3_months' | translate
              }}</div>
              <div ngbDropdownItem (click)="selectCalendarMode('6_months')">{{
                'calendarView_6_months' | translate
              }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }

  @if (isCriteriaForm2Enabled) {
    <div class="d-flex flex-column flex-xl-row align-items-center search-panel my-2 w-100">
      <div class="d-flex align-items-center filter-container">
        @if (isCriteriaForm2Enabled) {
          <div class="floating-label-dropdown-wrapper">
            <div
              class="search-block d-flex align-items-center search-dropdown active-product-dropdown"
              ngbDropdown
              [autoClose]="'outside'"
              [class.has-value]="campaignSearchParams?.activeProduct?.length">
              <label class="floating-label" [class.floating]="campaignSearchParams?.activeProduct?.length">
                {{ 'Active Product' | translate }}
              </label>
              <div class="dropdown-toggle w-100 mt-auto d-flex align-items-center p-0 pointer" ngbDropdownToggle>
                <div class="_400 p-3 dropdown-value _1-line-text-ellipsis">
                  {{ campaignSearchParams?.activeProduct?.join(', ') || '' }}
                </div>
                <div class="search-icon-div pointer ms-auto">
                  <i class="fa fa-chevron-down"></i>
                </div>
              </div>
              <div class="search-dropdown-menu w-100" ngbDropdownMenu>
                <div
                  class="d-flex align-items-center"
                  ngbDropdownItem
                  (click)="setActiveProduct('Yes')"
                  [class.active]="
                    campaignSearchParams?.activeProduct && campaignSearchParams?.activeProduct.indexOf('Yes') > -1
                  ">
                  <span>{{ 'Yes' | translate }}</span>
                  <label class="mtm-checkbox mtm-checkbox-green m-0 ms-auto" [style.pointer-events]="'none'">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      [checked]="
                        campaignSearchParams?.activeProduct && campaignSearchParams?.activeProduct.indexOf('Yes') > -1
                      " />
                    <span class="checkmark"></span>
                  </label>
                </div>
                <div
                  class="d-flex align-items-center"
                  ngbDropdownItem
                  (click)="setActiveProduct('No')"
                  [class.active]="
                    campaignSearchParams?.activeProduct && campaignSearchParams?.activeProduct.indexOf('No') > -1
                  ">
                  <span>{{ 'No' | translate }}</span>
                  <label class="mtm-checkbox mtm-checkbox-green m-0 ms-auto" [style.pointer-events]="'none'">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      [checked]="
                        campaignSearchParams?.activeProduct && campaignSearchParams?.activeProduct.indexOf('No') > -1
                      " />
                    <span class="checkmark"></span>
                  </label>
                </div>
                <div
                  ngbDropdownItem
                  class="d-flex align-items-center"
                  (click)="setActiveProduct('Finished')"
                  [class.active]="
                    campaignSearchParams?.activeProduct && campaignSearchParams?.activeProduct.indexOf('Finished') > -1
                  ">
                  <span>{{ 'Finished' | translate }}</span>
                  <label class="mtm-checkbox mtm-checkbox-green m-0 ms-auto" [style.pointer-events]="'none'">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      [checked]="
                        campaignSearchParams?.activeProduct &&
                        campaignSearchParams?.activeProduct.indexOf('Finished') > -1
                      " />
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        }

        @if (hasProductDevManager) {
          <div class="floating-label-dropdown-wrapper">
            <div
              class="search-block d-flex align-items-center search-dropdown product-dev-manager-dropdown"
              ngbDropdown
              [autoClose]="'outside'"
              [class.has-value]="campaignSearchParams?.projectLeaders?.length">
              <label class="floating-label" [class.floating]="campaignSearchParams?.projectLeaders?.length">
                {{ 'Product Dev Manager' | translate }}
              </label>
              <div class="dropdown-toggle w-100 mt-auto d-flex align-items-center p-0 pointer" ngbDropdownToggle>
                <div class="_400 p-3 dropdown-value d-flex align-items-center">
                  @if (campaignSearchParams?.projectLeaders?.length) {
                    @for (leader of campaignSearchParams?.projectLeaders?.slice(0, 3); track leader) {
                      <div>
                        <mtm-user-profile-picture
                          [forceLoadProfile]="true"
                          [username]="leader"
                          [height]="20"
                          [width]="20">
                        </mtm-user-profile-picture>
                      </div>
                    }
                    @if (campaignSearchParams?.projectLeaders?.length > 3) {
                      <div class="d-flex align-items-center justify-content-center _600 more-user">
                        {{ campaignSearchParams?.projectLeaders.length - 3 }}+
                      </div>
                    }
                  }
                </div>
                <div class="search-icon-div pointer ms-auto">
                  <i class="fa fa-chevron-down"></i>
                </div>
              </div>
              <div class="search-dropdown-menu w-100" ngbDropdownMenu>
                <div class="d-flex align-items-center mb-1">
                  <label class="m-0 f-8">All Product Dev Manager</label>
                  <label
                    class="mtm-checkbox mtm-checkbox-green m-0 ms-auto me-1 all"
                    (click)="selectAllProductDevManager($event)">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      [checked]="productDevManagers.length == campaignSearchParams?.projectLeaders?.length" />
                    <span class="checkmark"></span>
                  </label>
                </div>
                <input
                  class="form-control user-search-box mb-1"
                  [(ngModel)]="productDevQuery"
                  placeholder="Search..."
                  type="text" />
                @for (user of productDevManagers | searchUser: productDevQuery; track user.username) {
                  <div
                    ngbDropdownItem
                    class="d-flex align-items-center"
                    (click)="selectProductDevOwner(user.username)"
                    [class.active]="
                      campaignSearchParams?.projectLeaders &&
                      campaignSearchParams?.projectLeaders.indexOf(user.username) > -1
                    ">
                    <mtm-user-profile-picture
                      [forceLoadProfile]="true"
                      [user]="user"
                      [username]="user.username"
                      [height]="20"
                      [width]="20">
                    </mtm-user-profile-picture>
                    <div class="ms-2 _1-line-text-ellipsis">{{ user.fullName.trim() || user.username }}</div>
                    <label class="mtm-checkbox mtm-checkbox-green m-0 ms-auto" [style.pointer-events]="'none'">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        [checked]="
                          campaignSearchParams?.projectLeaders &&
                          campaignSearchParams?.projectLeaders.indexOf(user.username) > -1
                        " />
                      <span class="checkmark"></span>
                    </label>
                  </div>
                }
              </div>
            </div>
          </div>
        }

        @if (hasCncManager) {
          <div class="floating-label-dropdown-wrapper">
            <div
              class="search-block d-flex align-items-center search-dropdown leader-dropdown"
              ngbDropdown
              [autoClose]="'outside'"
              [class.has-value]="campaignSearchParams?.cncManagers?.length">
              <label class="floating-label" [class.floating]="campaignSearchParams?.cncManagers?.length">
                {{ 'C&C Leaders' | translate }}
              </label>
              <div class="dropdown-toggle w-100 mt-auto d-flex align-items-center p-0 pointer" ngbDropdownToggle>
                <div class="_400 p-3 dropdown-value d-flex align-items-center">
                  @if (campaignSearchParams?.cncManagers?.length) {
                    @for (cncManager of campaignSearchParams?.cncManagers.slice(0, 3); track cncManager) {
                      <div>
                        <mtm-user-profile-picture
                          [forceLoadProfile]="true"
                          [username]="cncManager"
                          [height]="20"
                          [width]="20">
                        </mtm-user-profile-picture>
                      </div>
                    }
                    @if (campaignSearchParams?.cncManagers?.length > 3) {
                      <div class="d-flex align-items-center justify-content-center _600 more-user">
                        {{ campaignSearchParams?.cncManagers?.length - 3 }}+
                      </div>
                    }
                  }
                </div>
                <div class="search-icon-div pointer ms-auto">
                  <i class="fa fa-chevron-down"></i>
                </div>
              </div>
              <div class="search-dropdown-menu w-100" ngbDropdownMenu>
                <div class="d-flex align-items-center mb-1">
                  <label class="m-0">All C&C Manager</label>
                  <label
                    class="mtm-checkbox mtm-checkbox-green m-0 ms-auto me-1 all"
                    (click)="selectAllCnCManager($event)">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      [checked]="cncManagers.length == campaignSearchParams?.cncManagers?.length" />
                    <span class="checkmark"></span>
                  </label>
                </div>
                <input
                  class="form-control user-search-box mb-1"
                  [(ngModel)]="cncQuery"
                  placeholder="Search..."
                  type="text" />
                @for (user of cncManagers | searchUser: cncQuery; track user.username) {
                  <div
                    ngbDropdownItem
                    class="d-flex align-items-center"
                    (click)="selectCnCManager(user.username)"
                    [class.active]="
                      campaignSearchParams?.cncManagers && campaignSearchParams?.cncManagers.indexOf(user.username) > -1
                    ">
                    <mtm-user-profile-picture
                      [forceLoadProfile]="true"
                      [user]="user"
                      [username]="user.username"
                      [height]="20"
                      [width]="20">
                    </mtm-user-profile-picture>
                    <div class="ms-2 _1-line-text-ellipsis">{{ user.fullName.trim() || user.username }}</div>
                    <label class="mtm-checkbox mtm-checkbox-green m-0 ms-auto" [style.pointer-events]="'none'">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        [checked]="
                          campaignSearchParams?.cncManagers &&
                          campaignSearchParams?.cncManagers.indexOf(user.username) > -1
                        " />
                      <span class="checkmark"></span>
                    </label>
                  </div>
                }
              </div>
            </div>
          </div>
        }

        @if (!isCriteriaForm1Enabled) {
          <div class="floating-label-dropdown-wrapper">
            <div
              class="search-block d-flex align-items-center search-dropdown mad-dropdown"
              ngbDropdown
              [autoClose]="'outside'"
              [class.has-value]="campaignSearchParams?.selectedMonths?.length && !firstInit">
              <label
                class="floating-label"
                [class.floating]="campaignSearchParams?.selectedMonths?.length && !firstInit">
                {{ 'MAD' | translate }}
              </label>
              <div class="dropdown-toggle w-100 mt-auto d-flex align-items-center p-0 pointer" ngbDropdownToggle>
                <div class="_400 p-3 dropdown-value _1-line-text-ellipsis">
                  {{ campaignSearchParams?.selectedMonths?.length ? madLabel : '' }}
                </div>
                <div class="search-icon-div pointer ms-auto">
                  <i class="fa fa-chevron-down"></i>
                </div>
              </div>
              <div class="search-dropdown-menu w-100" ngbDropdownMenu (click)="$event.stopImmediatePropagation()">
                <div class="d-flex align-items-center">
                  <label>All MAD</label>
                  <label class="mtm-checkbox mtm-checkbox-green m-0 ms-auto me-1 all" (click)="selectAllMad($event)">
                    <input class="form-check-input" type="checkbox" [checked]="yearSelected.length == years.length" />
                    <span class="checkmark"></span>
                  </label>
                </div>
                @for (year of years; track year) {
                  <div>
                    <div
                      ngbDropdownItem
                      class="d-flex align-items-center mad-value my-0"
                      [class.expanded]="monthCollapse[year]"
                      [class.active]="yearSelected.indexOf(year) > -1">
                      <div
                        [class.active]="yearSelected.indexOf(year) > -1"
                        class="year-dropdown-item"
                        [attr.aria-expanded]="monthCollapse[year]"
                        aria-controls="monthCollapse"
                        (click)="monthCollapse[year] = !monthCollapse[year]">
                        <span>{{ year }}</span>
                        <i class="fa fa-chevron-down search-icon-div ms-auto pointer"></i>
                      </div>
                      <label class="mtm-checkbox mtm-checkbox-green m-0 ms-1 me-1" (click)="selectYear($event, year)">
                        <input class="form-check-input" type="checkbox" [checked]="yearSelected.indexOf(year) > -1" />
                        <span class="checkmark"></span>
                      </label>
                    </div>
                    <div [ngbCollapse]="!monthCollapse[year]" class="sub-menu sub-menu-container pt-0 pb-0">
                      @for (month of months; track month) {
                        <div
                          class="dropdown-item d-flex align-items-center"
                          [class.active]="
                            campaignSearchParams?.selectedMonths &&
                            campaignSearchParams?.selectedMonths.indexOf(year + month) > -1
                          ">
                          <div>{{ `campaignFilterMonth_${month}` | translate }}</div>
                          <label
                            class="mtm-checkbox mtm-checkbox-green m-0 ms-auto me-1"
                            (click)="monthSelected($event, year, month)">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              [checked]="
                                campaignSearchParams?.selectedMonths &&
                                campaignSearchParams?.selectedMonths.indexOf(year + month) > -1
                              " />
                            <span class="checkmark"></span>
                          </label>
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        }
      </div>

      @if (isCriteriaForm2Enabled) {
        <div
          class="d-flex align-items-center second-filter-box w-100"
          style="flex-direction: row !important; min-width: 263px">
          <div class="search-block d-flex align-items-center search-dropdown sort-by-dropdown" ngbDropdown>
            <div class="dropdown-toggle w-100 mt-auto d-flex align-items-center p-0 pointer" ngbDropdownToggle>
              <div class="d-flex align-items-center">
                <span>{{ 'Sort By' | translate }}</span>
                @if (sortBy) {
                  <span class="_600 ms-1 me-1">{{ sortBy | translate }}</span>
                }
                <i class="fa fa-chevron-down ms-auto pointer"></i>
              </div>
            </div>
            <div class="search-dropdown-menu w-100" ngbDropdownMenu>
              <div ngbDropdownItem (click)="sortCampaign('Date')" [class.active]="sortBy === 'Date'"
                >{{ 'Date' | translate }}
              </div>
              <div ngbDropdownItem (click)="sortCampaign('Alphabetical')" [class.active]="sortBy === 'Alphabetical'">
                {{ 'Alphabetical' | translate }}</div
              >
              <div ngbDropdownItem (click)="sortCampaign('Status')" [class.active]="sortBy === 'Status'">{{
                'Status' | translate
              }}</div>
            </div>
          </div>
          <div class="position-relative search-container ms-auto me-sm-2">
            <input
              [(ngModel)]="searchDriveCampaign"
              class="search-box form-control ps-2 pe-4"
              (ngModelChange)="searchQueryChanged($event)"
              type="text"
              placeholder="{{ 'search' | translate }}" />
            <i class="fa fa-search search-icon" aria-hidden="true"></i>
          </div>
        </div>
      }
    </div>
  }
</ng-template>
